// Generated by Framer (1bcc82d)
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addFonts, addPropertyControls, ComponentViewportProvider, Container, ControlType, cx, GeneratedComponentContext, getFonts, PropertyOverrides, RenderTarget, useCustomCursors, useHydratedBreakpointVariants, useIsOnFramerCanvas, useLocaleInfo, withCSS } from "framer";
import { LayoutGroup, motion } from "framer-motion";
import * as React from "react";
import { useRef } from "react";
import NavBar from "#framer/local/canvasComponent/MXqfFzPbq/MXqfFzPbq.js";
import Footer from "#framer/local/canvasComponent/VB4yRsb1Z/VB4yRsb1Z.js";
const NavBarFonts = getFonts(NavBar);
const FooterFonts = getFonts(Footer);
const breakpoints = {
  ccMktGVKs: "(max-width: 809px)",
  oiAbvsf4V: "(min-width: 1440px)",
  Pk_SvzYc1: "(min-width: 810px) and (max-width: 1439px)"
};
const isBrowser = () => typeof document !== "undefined";
const serializationHash = "framer-9s6T1";
const variantClassNames = {
  ccMktGVKs: "framer-v-wcqt3f",
  oiAbvsf4V: "framer-v-1v8948n",
  Pk_SvzYc1: "framer-v-1l1lbps"
};
const breakpointRules = {
  ccMktGVKs: [".framer-9s6T1 .framer-qckek0 { flex-direction: column; padding: 0px 16px 0px 16px; }"]
};
const breakpointKeys = Object.keys(breakpointRules);
const selectors = {
  ccMktGVKs: ".framer-wcqt3f-override"
};
const rules = ["@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }", ".framer-9s6T1.framer-4i079t, .framer-9s6T1 .framer-4i079t { display: block; }", ".framer-9s6T1.framer-1v8948n { align-content: center; align-items: center; background-color: var(--token-202da0e8-7ad9-4bfb-98eb-ae8eca7d74ee, #08070e); display: flex; flex-direction: column; flex-wrap: nowrap; gap: 0px; height: min-content; justify-content: flex-start; overflow: hidden; padding: 0px; position: relative; width: 100%; }", ".framer-9s6T1 .framer-1g8rqds-container { flex: none; height: auto; left: 0px; position: var(--framer-canvas-fixed-position, fixed); top: 0px; width: 100%; z-index: 6; }", ".framer-9s6T1 .framer-17sq2fr { background: transparent; flex-grow: 1; height: 0px; margin: 0px; margin-bottom: -0px; position: relative; width: 0px; }", ".framer-9s6T1 .framer-qckek0 { --border-bottom-width: 1px; --border-color: var(--token-0aa53fec-fefb-40a3-a229-e26994a82701, rgba(95, 95, 113, 0.22)); --border-left-width: 0px; --border-right-width: 0px; --border-style: solid; --border-top-width: 1px; align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 0px; height: min-content; justify-content: center; order: 1002; overflow: visible; padding: 0px 24px 0px 24px; position: relative; width: 100%; z-index: 5; }", ".framer-9s6T1 .framer-1tt0jgu-container { flex: none; height: auto; max-width: 100%; position: relative; width: 1184px; }", '[data-layout-template="true"] > #overlay { margin-bottom: -0px; }', '.framer-9s6T1[data-border="true"]::after, .framer-9s6T1 [data-border="true"]::after { content: ""; border-width: var(--border-top-width, 0) var(--border-right-width, 0) var(--border-bottom-width, 0) var(--border-left-width, 0); border-color: var(--border-color, none); border-style: var(--border-style, none); width: 100%; height: 100%; position: absolute; box-sizing: border-box; left: 0; top: 0; border-radius: inherit; pointer-events: none; }'];
const mediaQueries = {
  ccMktGVKs: "(max-width: 809px)",
  oiAbvsf4V: "(min-width: 1440px)",
  Pk_SvzYc1: "(min-width: 810px) and (max-width: 1439px)"
};
const HTMLStyle = ({
  value
}) => {
  const onCanvas = useIsOnFramerCanvas();
  if (onCanvas) return null;
  return /*#__PURE__*/_jsx("style", {
    dangerouslySetInnerHTML: {
      __html: value
    },
    "data-framer-html-style": ""
  });
};
const humanReadableVariantMap = {
  Desktop: "oiAbvsf4V",
  Phone: "ccMktGVKs",
  Tablet: "Pk_SvzYc1"
};
const getProps = ({
  appearance,
  height,
  id,
  width,
  ...props
}) => {
  return {
    ...props,
    variant: humanReadableVariantMap[props.variant] ?? props.variant ?? "oiAbvsf4V",
    Z7VMRRT6h: appearance ?? props.Z7VMRRT6h
  };
};
const Component = /*#__PURE__*/React.forwardRef(function (props, ref) {
  const fallbackRef = useRef(null);
  const refBinding = ref ?? fallbackRef;
  const defaultLayoutId = React.useId();
  const {
    activeLocale,
    setLocale
  } = useLocaleInfo();
  const {
    style,
    className,
    layoutId,
    variant,
    Z7VMRRT6h,
    children,
    ...restProps
  } = getProps(props);
  const [baseVariant, hydratedBaseVariant] = useHydratedBreakpointVariants(variant, breakpoints, false);
  const gestureVariant = undefined;
  const sharedStyleClassNames = [];
  const scopingClassNames = cx(serializationHash, ...sharedStyleClassNames);
  useCustomCursors({});
  return /*#__PURE__*/_jsx(GeneratedComponentContext.Provider, {
    value: {
      isLayoutTemplate: true,
      primaryVariantId: "oiAbvsf4V",
      variantClassNames
    },
    children: /*#__PURE__*/_jsxs(LayoutGroup, {
      id: layoutId ?? defaultLayoutId,
      children: [/*#__PURE__*/_jsx(HTMLStyle, {
        value: ":root body { background: var(--token-202da0e8-7ad9-4bfb-98eb-ae8eca7d74ee, rgb(8, 7, 14)); }"
      }), /*#__PURE__*/_jsxs(motion.div, {
        ...restProps,
        className: cx(scopingClassNames, "framer-1v8948n", className),
        "data-layout-template": true,
        ref: refBinding,
        style: {
          ...style
        },
        children: [/*#__PURE__*/_jsx(ComponentViewportProvider, {
          height: 96,
          width: "100vw",
          y: 0,
          children: /*#__PURE__*/_jsx(Container, {
            className: "framer-1g8rqds-container",
            layoutScroll: true,
            nodeId: "l8EKIq0DB",
            scopeId: "fhv6dLWsC",
            children: /*#__PURE__*/_jsx(PropertyOverrides, {
              breakpoint: baseVariant,
              overrides: {
                ccMktGVKs: {
                  variant: "fmKE710k7"
                },
                Pk_SvzYc1: {
                  variant: "fmKE710k7"
                }
              },
              children: /*#__PURE__*/_jsx(NavBar, {
                height: "100%",
                id: "l8EKIq0DB",
                IFQnKk1ZS: Z7VMRRT6h,
                layoutId: "l8EKIq0DB",
                style: {
                  width: "100%"
                },
                variant: "vvHTF7cU2",
                width: "100%"
              })
            })
          })
        }), children, /*#__PURE__*/_jsx("div", {
          className: "framer-17sq2fr"
        }), /*#__PURE__*/_jsx("footer", {
          className: "framer-qckek0",
          "data-border": true,
          "data-framer-name": "Footer",
          children: /*#__PURE__*/_jsx(ComponentViewportProvider, {
            height: 327,
            width: "min(1184px, 100vw)",
            y: 1e3,
            children: /*#__PURE__*/_jsx(Container, {
              className: "framer-1tt0jgu-container",
              nodeId: "soz3MXq_q",
              scopeId: "fhv6dLWsC",
              children: /*#__PURE__*/_jsx(PropertyOverrides, {
                breakpoint: baseVariant,
                overrides: {
                  ccMktGVKs: {
                    variant: "INLWkWGjB"
                  },
                  Pk_SvzYc1: {
                    variant: "lr5iESJyk"
                  }
                },
                children: /*#__PURE__*/_jsx(Footer, {
                  height: "100%",
                  id: "soz3MXq_q",
                  layoutId: "soz3MXq_q",
                  style: {
                    maxWidth: "100%",
                    width: "100%"
                  },
                  variant: "azE7Y4AM7",
                  width: "100%"
                })
              })
            })
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        id: "template-overlay"
      })]
    })
  });
});
const css = target => {
  const isStaticRenderer = target === RenderTarget.canvas || target === RenderTarget.export;
  if (!isStaticRenderer) {
    return [...rules, ...breakpointKeys.map(key => {
      const query = mediaQueries[key];
      return `@media ${query} { ${breakpointRules[key].join(" ")} }`;
    })];
  }
  return [...rules, ...breakpointKeys.flatMap(key => {
    const selector = selectors[key];
    return breakpointRules[key].map(rule => `${selector} {${rule}}`);
  })];
};
/**
 * This is a generated Framer component.
 * @framerIntrinsicHeight 1000
 * @framerIntrinsicWidth 1440
 * @framerCanvasComponentVariantDetails {"propertyName":"variant","data":{"default":{"layout":["fixed","fixed"]},"Pk_SvzYc1":{"layout":["fixed","fixed"]},"ccMktGVKs":{"layout":["fixed","fixed"]}}}
 * @framerVariables {"Z7VMRRT6h":"appearance"}
 * @framerImmutableVariables true
 * @framerDisplayContentsDiv false
 * @framerAutoSizeImages true
 * @framerComponentViewportWidth true
 * @framerColorSyntax true
 * @framerHitTargets {"oiAbvsf4V":[".framer-1g8rqds-container",".framer-qckek0"],"Pk_SvzYc1":[".framer-1g8rqds-container",".framer-qckek0"],"ccMktGVKs":[".framer-1g8rqds-container",".framer-qckek0"]}
 * @framerBreakpoints {"oiAbvsf4V":{"min":1440,"canvasClassName":"framer-1v8948n-override","minHeight":1000,"name":"Desktop","width":1440,"rootFontSize":16},"Pk_SvzYc1":{"min":810,"max":1439,"canvasClassName":"framer-1l1lbps-override","minHeight":1000,"viewportHeight":1080,"name":"Tablet","width":810,"rootFontSize":16},"ccMktGVKs":{"max":809,"canvasClassName":"framer-wcqt3f-override","minHeight":1000,"viewportHeight":844,"name":"Phone","width":390,"rootFontSize":16}}
 * @framerDefaultVariant oiAbvsf4V
 * @framerLayoutTemplate
 */
const Framerfhv6dLWsC = withCSS(Component, css, "framer-9s6T1");
export default Framerfhv6dLWsC;
Framerfhv6dLWsC.displayName = "Layout-NavBar-Footer";
Framerfhv6dLWsC.defaultProps = {
  height: 1e3,
  width: 1440
};
addPropertyControls(Framerfhv6dLWsC, {
  Z7VMRRT6h: {
    description: "Select a section where the navigation background should appear.",
    title: "Appearance",
    type: ControlType.ScrollSectionRef
  }
});
addFonts(Framerfhv6dLWsC, [{
  explicitInter: true,
  fonts: []
}, ...NavBarFonts, ...FooterFonts], {
  supportsExplicitInterCodegen: true
});
export const __FramerMetadata__ = {
  exports: {
    Props: {
      type: "tsType",
      annotations: {
        framerContractVersion: "1"
      }
    },
    default: {
      type: "reactComponent",
      name: "Framerfhv6dLWsC",
      slots: [],
      annotations: {
        framerDisplayContentsDiv: "false",
        framerDefaultVariant: "oiAbvsf4V",
        framerBreakpoints: '{"oiAbvsf4V":{"min":1440,"canvasClassName":"framer-1v8948n-override","minHeight":1000,"name":"Desktop","width":1440,"rootFontSize":16},"Pk_SvzYc1":{"min":810,"max":1439,"canvasClassName":"framer-1l1lbps-override","minHeight":1000,"viewportHeight":1080,"name":"Tablet","width":810,"rootFontSize":16},"ccMktGVKs":{"max":809,"canvasClassName":"framer-wcqt3f-override","minHeight":1000,"viewportHeight":844,"name":"Phone","width":390,"rootFontSize":16}}',
        framerHitTargets: '{"oiAbvsf4V":[".framer-1g8rqds-container",".framer-qckek0"],"Pk_SvzYc1":[".framer-1g8rqds-container",".framer-qckek0"],"ccMktGVKs":[".framer-1g8rqds-container",".framer-qckek0"]}',
        framerContractVersion: "1",
        framerLayoutTemplate: "",
        framerVariables: '{"Z7VMRRT6h":"appearance"}',
        framerAutoSizeImages: "true",
        framerImmutableVariables: "true",
        framerColorSyntax: "true",
        framerComponentViewportWidth: "true",
        framerIntrinsicWidth: "1440",
        framerIntrinsicHeight: "1000",
        framerCanvasComponentVariantDetails: '{"propertyName":"variant","data":{"default":{"layout":["fixed","fixed"]},"Pk_SvzYc1":{"layout":["fixed","fixed"]},"ccMktGVKs":{"layout":["fixed","fixed"]}}}'
      }
    },
    __FramerMetadata__: {
      type: "variable"
    }
  }
};